import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconTick = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 15,
	height: 11,
	viewBox: "0 0 15 11",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1 5.5L5.33455 10L14 1",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgIconTick;
